export const customLayers = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_CUSTOM_LAYERS':
      return {
        ...state,
        ...action.payload.layers.reduce((acc, layer) => {
          acc[layer.key] = {
            ...(state[layer.key] || {}),
            ...layer,
          };
          return acc;
        }, {}),
      };
    case 'REMOVE_CUSTOM_LAYERS': {
      const newState = { ...state };
      delete newState[action.payload.key];
      return newState;
    }
    case 'REMOVE_LOCAL_CUSTOM_LAYERS': {
      const newState = { ...state };
      delete newState[action.payload.key];
      return newState;
    }
    case 'REMOVE_USERS_FROM_LAYER': {
      const newState = { ...state };
      const users = newState[action.payload.layerId].users || [];
      newState[action.payload.layerId].users = users.filter(
        ({ id }) => !action.payload.userIds.includes(id),
      );
      return newState;
    }
    case 'ADD_USERS_TO_LAYER': {
      const newState = { ...state };
      const users = [
        ...action.payload.users,
        ...(newState[action.payload.layerId].users || []),
      ];
      newState[action.payload.layerId].users = users;
      return newState;
    }
    default:
      return state;
  }
};
